const transaction = {
  dialogs: {
    warnings: {
      createCashback:
        'This will create a cashback for this transaction.\nAre you sure you want to proceed?',
      forceCreateCashback:
        'The membership state was inactive at the date of transaction.\nAre you sure you want to proceed anyway?',
      deleteCashback:
        'This will delete the cashback for this transaction.\nAre you sure you want to proceed?',
      pendingTransaction:
        "This is a pending transaction.\nPlease wait until it's approved.",
      updateStore: "Please update transaction's store information first.",
      removeCashback: 'In order to change store, please remove cashback',
      invalidStore: 'FastCash is not enabled for this store',
      missingStore: '\nYou need to select a STORE for all the transactions.',
      forceCreateCashbackList:
        'The membership state was inactive at the date of transaction. Select which you want to process:\nAre you sure you want to proceed?',
    },
  },
};

export default transaction;
